
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceintalawade() {



const cardData = {
  keyword: 'Cab Service in Talwade MIDC Pune',
  heading: 'eTravo: Premier Corporate Cab Services in Talwade MIDC Pune for Industrial Excellence',
  headingDescription: 'eTravo offers trusted and efficient corporate cab services in Talwade MIDC Pune, addressing the complex transportation demands of industries, employees, and corporate clients in this growing industrial hub. Our fleet includes GPS-enabled, air-conditioned vehicles driven by trained professionals, ensuring safety, comfort, and punctuality. Whether you need regular employee commute services, executive transfers, or client transportation, eTravo delivers tailored and scalable solutions designed to optimize your corporate mobility across Talwade MIDC and its adjoining regions.',

  top: 'Major Industrial and Corporate Locations in Talwade MIDC Pune Served by eTravo',
  topPlaces: [
    {
      title: 'Talwade Industrial Park',
      description: 'A key industrial zone with a wide range of manufacturing and engineering companies. Our cab services ensure smooth and timely transportation for employees working across various shifts and departments.'
    },
    {
      title: 'Technology and R&D Centers',
      description: 'Talwade hosts several research and development units requiring reliable and secure transportation for their technical staff and visiting experts.'
    },
    {
      title: 'Logistics and Warehousing Facilities',
      description: 'Efficient cab solutions for logistics personnel facilitating on-time delivery and operations within the industrial complex.'
    },
    {
      title: 'Corporate Offices and Administrative Centers',
      description: 'Providing comfortable and professional transport for office staff, executives, and visiting clients, enhancing business efficiency.'
    },
    {
      title: 'Talwade MIDC Bus Stops and Transit Points',
      description: 'Bridging the gap between public transport and workplace with last-mile connectivity, improving overall employee commute experience.'
    },
    {
      title: 'Nearby Residential Areas',
      description: 'Connecting residential localities with Talwade MIDC, enabling timely and hassle-free travel for industrial workforce and corporate teams.'
    },
    {
      title: 'Training Institutes and Skill Development Centers',
      description: 'Supporting travel requirements for trainees, instructors, and corporate guests attending workshops and programs within Talwade MIDC.'
    },
    {
      title: 'Healthcare Facilities',
      description: 'Ensuring prompt and safe transport options for employees and visitors accessing medical centers in and around Talwade MIDC.'
    },
    {
      title: 'Visitor and Client Access Points',
      description: 'Reliable and comfortable transportation for clients and visitors attending meetings, audits, and corporate events within Talwade MIDC.'
    },
    {
      title: 'Emergency and Support Services',
      description: 'Quick and dependable cab services facilitating urgent employee travel and emergency responses within the industrial zone.'
    }
  ],

  services: [
    {
      name: 'Talwade MIDC Corporate Cab Rentals',
      description: 'Customizable cab rental plans designed to meet the diverse needs of businesses, offering long-term contracts, flexible payment options, and dedicated fleet management.'
    },
    {
      name: 'Employee Transport Cab Talwade MIDC',
      description: 'Daily and shift-based employee transport services with GPS tracking, ensuring punctual pick-ups and safe drop-offs to improve workforce reliability.'
    },
    {
      name: 'Business Cab Services Talwade MIDC',
      description: 'Versatile fleet options including sedans, SUVs, and executive cars catering to business owners, field staff, and visiting clients.'
    },
    {
      name: 'Corporate Staff Cabs Talwade MIDC',
      description: 'Structured transportation services with multi-stop routes and shift-wise scheduling to enhance operational efficiency and employee satisfaction.'
    },
    {
      name: 'Reliable Corporate Cab Service Talwade MIDC',
      description: 'Commitment to providing clean, timely, and professionally driven cabs, trusted by numerous corporations in Talwade MIDC for everyday travel needs.'
    },
    {
      name: 'AC Corporate Cabs Talwade MIDC',
      description: 'Fully air-conditioned, sanitized vehicles equipped for comfortable journeys even during peak summers and monsoon seasons.'
    },
    {
      name: 'Staff Pickup and Drop Cab Talwade MIDC',
      description: '24/7 scheduled pickup and drop services tailored to company shift timings, ensuring smooth employee transitions and minimizing downtime.'
    },
    {
      name: 'Affordable Business Cab Rentals Talwade MIDC',
      description: 'Cost-effective solutions featuring flexible billing,  capabilities, and monthly rental contracts designed for all business scales.'
    },
    {
      name: 'Executive Cab Services Talwade MIDC',
      description: 'Premium transportation for executives and VIPs with luxury vehicles and professional chauffeurs focused on discretion and punctuality.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Talwade MIDC',
      description: 'Comprehensive monthly cab rental services providing route optimization, dedicated fleet, and real-time monitoring to enhance travel management.'
    },
    {
      name: 'Industrial Area Employee Transport Talwade MIDC',
      description: 'End-to-end transport solutions for industrial staff, facilitating multi-stop routes, shift-based timing, and safety protocols within Talwade MIDC.'
    },
    {
      name: 'Corporate Client Cabs Talwade MIDC',
      description: 'Professional and comfortable cabs dedicated to client visits, business meetings, and corporate events, ensuring timely and impressive travel experiences.'
    },
    {
      name: 'Business Meeting Cabs Talwade MIDC',
      description: 'On-demand and scheduled cab services for flexible business travel needs, ensuring responsiveness and convenience within and outside Talwade MIDC.'
    },
    {
      name: 'Talwade Industrial Area Cab Hire',
      description: 'Dedicated cab hire options for daily commutes, inter-office travel, and corporate events, supported by a scalable fleet tailored to your needs.'
    },
    {
      name: 'Corporate Shuttle Cabs Talwade MIDC',
      description: 'Group shuttle services designed for efficient team transportation across industrial units, transit hubs, and residential areas in Talwade MIDC.'
    }
  ],

  tableData: [
    ['Talwade MIDC Corporate Cab Rentals', 'Employee Transport Cab Talwade MIDC'],
    ['Business Cab Services Talwade MIDC', 'Corporate Staff Cabs Talwade MIDC'],
    ['Reliable Corporate Cab Service Talwade MIDC', 'AC Corporate Cabs Talwade MIDC'],
    ['Staff Pickup and Drop Cab Talwade MIDC', 'Affordable Business Cab Rentals Talwade MIDC'],
    ['Executive Cab Services Talwade MIDC', 'Monthly Corporate Cab Rentals Talwade MIDC'],
    ['Industrial Area Employee Transport Talwade MIDC', 'Corporate Client Cabs Talwade MIDC'],
    ['Business Meeting Cabs Talwade MIDC', 'Talwade Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Talwade MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Customized Corporate Cab Services for Talwade MIDC Pune",
        "WhyChoosedescription": "eTravo provides specialized cab services tailored specifically for businesses operating in Talwade Industrial Area MIDC, Pune. Understanding the fast-paced and dynamic nature of this industrial zone, we deliver reliable, punctual, and comfortable transportation solutions that help companies optimize employee commute times, reduce stress, and improve overall operational efficiency. Our services are designed to meet the unique scheduling and logistical needs of Talwade’s corporate community."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Suit All Corporate Travel Needs",
        "WhyChoosedescription": "Our diverse fleet includes sedans, SUVs, and MUVs, enabling businesses to select vehicles that best match their specific requirements—whether it's daily employee transport, client meetings, or inter-office travel within Pune and nearby areas. We prioritize safety, comfort, and professionalism across all our vehicles."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Expert Knowledge of Talwade MIDC Routes",
        "WhyChoosedescription": "Our drivers are trained professionals who possess in-depth familiarity with Talwade MIDC and the surrounding Pune industrial corridors. Their local knowledge ensures efficient navigation, timely pickups, and a smooth travel experience, minimizing delays and maximizing reliability."
    },
    {
        "WhyChooseheading": "Flexible Booking and Scheduling Options for Corporate Clients",
        "WhyChoosedescription": "We offer flexible booking solutions including on-demand rides, scheduled pickups, and long-term contracts tailored to the diverse needs of corporate clients. This flexibility allows businesses to align transportation services with shifting project schedules and employee work hours seamlessly."
    },
    {
        "WhyChooseheading": "Advanced Real-Time GPS Tracking for Enhanced Safety and Transparency",
        "WhyChoosedescription": "All our cabs are equipped with GPS tracking systems, allowing corporate clients to monitor rides in real-time. This feature ensures passenger safety, enables quick responses to any disruptions, and promotes full transparency in employee transportation."
    },
    {
        "WhyChooseheading": "Transparent Billing with Detailed Invoices for Easy Financial Management",
        "WhyChoosedescription": "Our billing system offers clear, itemized invoices detailing trip logs, fare breakdowns, and additional charges, facilitating easy expense tracking and reimbursement for corporate finance teams."
    },
    {
        "WhyChooseheading": "Strict Adherence to Safety and Hygiene Protocols",
        "WhyChoosedescription": "Committed to passenger health and wellbeing, we enforce rigorous hygiene standards including regular vehicle sanitization, driver health checks, and mask usage. These protocols ensure a safe and comfortable environment for all passengers."
    },
    {
        "WhyChooseheading": "Dedicated Corporate Account Management for Personalized Support",
        "WhyChoosedescription": "Every corporate client is assigned a dedicated account manager who provides personalized assistance with bookings, addresses queries promptly, and tailors transportation services to meet specific business needs, ensuring a seamless and efficient experience."
    }
]
}

const faqData = [
    [
        {
            question: "Which areas are covered by your cab services in Talwade MIDC Pune?",
            answer: "Our services cover Talwade Industrial Area MIDC and adjacent industrial and commercial zones within Pune, providing comprehensive corporate transportation solutions."
        },
        {
            question: "Can we schedule regular rides for employees in Talwade MIDC?",
            answer: "Yes, we provide options for scheduling recurring rides to ensure consistent and dependable transportation for your workforce."
        },
        {
            question: "Is monthly billing available for corporate clients?",
            answer: "Absolutely. We offer monthly billing with detailed invoices to simplify expense tracking and management."
        },
        {
            question: "Are your drivers trained in corporate etiquette and professionalism?",
            answer: "Yes, our drivers receive extensive training to maintain high standards of professionalism, courtesy, and safety."
        },
        {
            question: "How do you ensure passenger safety during the rides?",
            answer: "We employ GPS tracking, perform regular vehicle maintenance, and adhere to strict hygiene and safety protocols, including sanitization and mask usage."
        },
        {
            question: "Do you offer dedicated support for corporate clients in Talwade MIDC?",
            answer: "Yes, corporate clients benefit from dedicated account managers and support teams for prompt assistance and customized service."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Sandeep Patil",
        designation: "Operations Manager, PuneTech Solutions",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s cab services in Talwade MIDC Pune have greatly improved our employee commute experience with timely pickups and excellent support.”"
    },
    {
        name: "Ms. Kavya More",
        designation: "HR Lead, Innovatech Industries",
        rating: [1, 1, 1, 1, 1],
        text: "“The professionalism, reliability, and flexible booking options offered by eTravo make them our preferred corporate transportation partner.”"
    }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Talwade MIDC Pune",
  "image": "https://www.etravo.in/images/keyword/cab-service-talwade-midc.jpg",
  "description": "Reliable corporate cab service in Talwade MIDC Pune for employee transport, business meetings, and industrial commutes. Affordable AC corporate cabs with trusted drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7945"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-talwade-midc-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Talwade MIDC Pune | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Talwade MIDC Pune for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceintalawade;